import { Reveal, Eyebrow } from "@/components/Reveal";

const POINTS = [
    {
        n: "01",
        title: "Approccio su misura",
        text: "Ogni lavorazione parte dalle esigenze specifiche del cliente.",
    },
    {
        n: "02",
        title: "Flessibilità",
        text: "Una struttura familiare permette un rapporto diretto e un approccio pratico alle richieste.",
    },
    {
        n: "03",
        title: "Competenza",
        text: "Mettiamo a disposizione macchinari e competenze per affrontare diverse lavorazioni meccaniche.",
    },
    {
        n: "04",
        title: "Attenzione al dettaglio",
        text: "Curiamo il processo di lavorazione per ottenere un risultato coerente con le richieste ricevute.",
    },
];

export default function Perche() {
    return (
        <section
            data-testid="perche-section"
            className="blueprint-grid bg-tl-dark3 py-20 md:py-28"
        >
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-12">
                <Reveal>
                    <Eyebrow number="05" label="I nostri valori" />
                </Reveal>
                <Reveal delay={0.1}>
                    <h2 className="mt-6 max-w-2xl font-display text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">
                        Perché TECNO-LAV<span className="text-tl-orange">.</span>
                    </h2>
                </Reveal>

                <div className="mt-14 grid gap-px bg-white/10 sm:grid-cols-2 lg:grid-cols-4">
                    {POINTS.map((p, i) => (
                        <Reveal key={p.n} delay={0.07 * i} y={24}>
                            <div
                                data-testid={`perche-item-${i}`}
                                className="group h-full bg-tl-dark3 p-8 transition-colors duration-300 hover:bg-tl-dark2"
                            >
                                <span className="font-mono-tl text-3xl font-semibold text-tl-orange/90">
                                    {p.n}
                                </span>
                                <h3 className="mt-8 font-display text-lg font-semibold uppercase tracking-wide text-white">
                                    {p.title}
                                </h3>
                                <p className="mt-4 text-sm leading-relaxed text-tl-mutedLight">
                                    {p.text}
                                </p>
                                <span className="mt-6 block h-px w-8 bg-tl-orange transition-[width] duration-500 group-hover:w-16" />
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
